import React from 'react'
import { Link } from 'react-router-dom'
import { routes } from '../../constantes/routes'
import LogoPalex from '../../assests/img/02_Palex_ConClaim_Color.svg'

export default function PalexLogo() {
  const styleLogo = {
    width: '329px',
    height: '35px',
  }

  return (
    <Link to={routes.MAIN}>
      <img style={styleLogo} src={LogoPalex} alt='Palex Logo'></img>
    </Link>
  )
}
